import * as React from 'react';
import { FieldArray } from 'formik';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Input } from 'src/components/Shared/BsInput';
import ContentsSearchModal from 'src/containers/Shared/ContentsSearchModal';
import { LANGUAGES } from 'src/globals';

export default class Cards extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      modalOpened: false,
    };
    this.renderSelected = this.renderSelected.bind(this);
  }

  public toggleModal = () => {
    this.setState({ modalOpened: !this.state.modalOpened });
  }

  public render() {
    const { values, setFieldValue } = this.props;
    return (
      <div>
        <ContentsSearchModal
          opened={this.state.modalOpened}
          toggleModal={this.toggleModal}
          onSelect={(content: any) => {
            content.ContentTranslations.forEach((ct: any) => {
              if (ct.title) {
                const val = values.data.breadcrumbs[ct.language].concat({
                  order: values.data.breadcrumbs[ct.language].length || 0,
                  title: ct.title || '',
                  url: ct.slug || '',
                });
                setFieldValue(`data.breadcrumbs.${ct.language}`, val);
              }
            });

            this.toggleModal();
          }}
        />
        <Tabs className="nav-fill" style={{ cursor: 'pointer' }}>
          <TabList>
            {
              Object.keys(LANGUAGES).map((key: string, i: number) => (
                <Tab key={i}>{LANGUAGES[key]}</Tab>
              ))
            }
          </TabList>
          {
            Object.keys(LANGUAGES).map((key: string, i: number) => (
              <TabPanel key={i}>
                <FieldArray
                  name={`data.breadcrumbs.${key}`}
                  render={(arrayHelpers) => {
                    return (
                      <div>
                        <div className="text-right">
                          <button 
                            className="btn btn-primary btn-xs"
                            onClick={this.toggleModal}
                            type="button"
                          >
                            <i className="fa fa-plus-circle"></i>
                          </button>
                        </div>
                        <div className="form-group pt-3">
                        </div>
                        {
                          values.data.breadcrumbs[key].map((d: any, ii: number) =>
                            this.renderSelected(d, key, ii, arrayHelpers)
                          )
                        }
                      </div>
                    );
                  }}
                />
              </TabPanel>
            ))
          }
        </Tabs>
      </div>
    )
  }

  private renderSelected(crumb: any, lang: string, index: number, arrayHelpers: any) {
    const { errors } = this.props;
    return (
      <div className="card mb-3" key={index}>
        <div className="card-body">
          <div className="row">
            <div className="col">
              <Input
                label="Orden"
                value={crumb.order}
                name={`data.breadcrumbs.${lang}.${index}.order`}
                onChange={this.props.handleChange}
                errors={errors}
                type="number"
              />
            </div>
            <div className="col">
              <Input
                label="Titulo"
                value={crumb.title}
                name={`data.breadcrumbs.${lang}.${index}.title`}
                onChange={this.props.handleChange}
                errors={errors}
                type="text"
                readOnly
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                label="URL"
                value={crumb.url}
                name={`data.breadcrumbs.${lang}.${index}.url`}
                onChange={this.props.handleChange}
                errors={errors}
                type="text"
                readOnly
              />
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="text-right">
            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={(e) => {
                e.preventDefault();
                arrayHelpers.remove(index);
              }}
            >
              <i className="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>

    );
  };
}



// WEBPACK FOOTER //
// ./src/containers/Module/Types/Breadcrumbs.tsx